import { getEnvName } from '@/utils/getEnvVars'
import { Button } from '@sevenrooms/ui-kit/form'
import { VStack } from '@sevenrooms/ui-kit/layout'
import { Text } from '@sevenrooms/ui-kit/typography'
import { ErrorHeader } from './ErrorHeader'

interface ErrorPageProps {
  error?: string | Error | unknown
}

export function ErrorPage({ error }: ErrorPageProps) {
  const isProd = getEnvName() === 'PROD'
  return (
    <VStack height="100vh" width="100vw">
      <ErrorHeader />
      <VStack width="100%" flexGrow={1} alignItems="center" backgroundColor="darkFont" spacing="m" pt="m">
        <Text textStyle="body1" color="lightFont">
          {isProd ? 'Something went wrong' : error?.toString()}
        </Text>
        <Button
          data-test="sr-error-page-go-back"
          variant="primary"
          onClick={() => {
            window.history.back()
          }}
        >
          <Text color="lightFont">Go back</Text>
        </Button>
      </VStack>
    </VStack>
  )
}
